export const runsOnNode = (): boolean => {
  return (
    navigator.userAgent.includes('Node.js') ||
    navigator.userAgent.includes('jsdom')
  );
};
